import { useNavigate } from 'react-router-dom';
import { useScreenView } from '../../../../../utils/ScreenViewContext';

interface SettingsMenuProps {
  selectedSettingsTab: SettingsTab;
  setSelectedSettingsTab: (tab: SettingsTab) => void;
}

export enum SettingsTab {
  Integrations = 'integrations',
  SystemPreferences = 'system_preferences',
  Security = 'security',
  Support = 'support',
  Backup = 'backup',
  LinkedAccounts = 'linked_accounts',
  Account = 'account',
}

const settingsTabs: { name: string; tab: SettingsTab }[] = [
  // { name: 'System Preferences', tab: SettingsTab.SystemPreferences },
  // { name: 'Security', tab: SettingsTab.Security },
  { name: 'Account', tab: SettingsTab.Account },
  { name: 'Integrations', tab: SettingsTab.Integrations },
  // { name: 'Support', tab: SettingsTab.Support },
  // { name: 'Backup', tab: SettingsTab.Backup },
  { name: 'Linked Accounts', tab: SettingsTab.LinkedAccounts },
];

function SettingsMenu({
  selectedSettingsTab,
  setSelectedSettingsTab,
}: SettingsMenuProps) {
  const navigate = useNavigate();
  const { screenView } = useScreenView();
  const renderScreenView = (screenView: string) => {
    switch (screenView) {
      case 'desktop':
        return (
          <div className="flex h-[46px] max-h-[46px] w-fit flex-row items-center justify-start rounded-full border-[1px] border-[#EAECF0] bg-white align-middle text-[14px] text-[#717682]">
            {settingsTabs.map((tabObj) => (
              <button
                key={tabObj?.name}
                className={`${selectedSettingsTab === tabObj?.tab && 'rounded-full border-[1px] border-[#F7A826] bg-[#FEF6E9] text-[#312F36]'} px-[32px] py-[10px]`}
                onClick={() => {
                  setSelectedSettingsTab(tabObj?.tab);
                  navigate(
                    `/dashboard/settings/${tabObj?.name.toLowerCase().split(' ').join('-')}`
                  );
                }}
              >
                {tabObj?.name}
              </button>
            ))}
          </div>
        );
      case 'tablet':
        return (
          <div className="flex h-[46px] max-h-[46px] w-fit flex-row items-center justify-start rounded-full border-[1px] border-[#EAECF0] bg-white align-middle text-[14px] text-[#717682]">
            {settingsTabs.map((tabObj) => (
              <button
                className={`${selectedSettingsTab === tabObj?.tab && 'rounded-full border-[1px] border-[#F7A826] bg-[#FEF6E9] text-[#312F36]'} px-2 py-[10px]`}
                onClick={() => {
                  setSelectedSettingsTab(tabObj?.tab);
                  navigate(
                    `/dashboard/settings/${tabObj?.name.toLowerCase().split(' ').join('-')}`
                  );
                }}
              >
                {tabObj?.name}
              </button>
            ))}
          </div>
        );
      case 'mobile':
        return (
          <div className="flex h-[46px] max-h-[46px] w-fit flex-row items-center justify-start overflow-x-auto whitespace-nowrap rounded-full border-[1px] border-[#EAECF0] bg-white align-middle text-[12px] text-[#717682]">
            {settingsTabs.map((tabObj) => (
              <button
                className={`${selectedSettingsTab === tabObj?.tab && 'rounded-full border-[1px] border-[#F7A826] bg-[#FEF6E9] text-[#312F36]'} px-2 py-[10px]`}
                onClick={() => {
                  setSelectedSettingsTab(tabObj?.tab);
                  navigate(
                    `/dashboard/settings/${tabObj?.name.toLowerCase().split(' ').join('-')}`
                  );
                }}
              >
                {tabObj?.name}
              </button>
            ))}
          </div>
        );
    }
  };

  return <>{renderScreenView(screenView)}</>;
}

export default SettingsMenu;
